import { Inject, Injectable } from '@angular/core';
import { first, map, shareReplay } from 'rxjs';
import { ApiService, LIBRARY_CONFIG } from '../../../shared';
import * as i0 from "@angular/core";
export class AppService extends ApiService {
  injector;
  path = 'registration-service/v1/apps/me';
  apiVersion = '1';
  cache$;
  constructor(injector, libConfig) {
    super(injector, libConfig);
    this.injector = injector;
    if (!this.baseUrl) {
      console.warn('AppService: baseUrl is not provided, apps for the header will not be fetched');
    }
  }
  getAllApps() {
    if (!this.cache$) {
      this.cache$ = this.get(this.path, {}, this.apiVersion).pipe(first(), shareReplay(1));
    }
    return this.cache$;
  }
  getVerifiedApps() {
    return this.getAllApps().pipe(map(apps => apps.filter(app => !app.locked)));
  }
  static ɵfac = function AppService_Factory(t) {
    return new (t || AppService)(i0.ɵɵinject(i0.Injector), i0.ɵɵinject(LIBRARY_CONFIG));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AppService,
    factory: AppService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i0.Injector
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [LIBRARY_CONFIG]
    }]
  }], null);
})();
